/**
 * Curated `:shortcode:` → emoji map for the composer autocomplete (typing
 * `:jo` suggests 😂, Web A style). Names follow the common Telegram/GitHub
 * shortcode vocabulary; only glyphs present in the Apple sprite set are used.
 */
export const EMOJI_SHORTCODES: { name: string; emoji: string }[] = [
  { name: "joy", emoji: "😂" },
  { name: "rofl", emoji: "🤣" },
  { name: "smile", emoji: "😄" },
  { name: "grin", emoji: "😁" },
  { name: "laughing", emoji: "😆" },
  { name: "sweat_smile", emoji: "😅" },
  { name: "wink", emoji: "😉" },
  { name: "blush", emoji: "😊" },
  { name: "innocent", emoji: "😇" },
  { name: "heart_eyes", emoji: "😍" },
  { name: "smiling_face_with_hearts", emoji: "🥰" },
  { name: "kiss", emoji: "😘" },
  { name: "yum", emoji: "😋" },
  { name: "tongue", emoji: "😛" },
  { name: "zany", emoji: "🤪" },
  { name: "sunglasses", emoji: "😎" },
  { name: "nerd", emoji: "🤓" },
  { name: "party", emoji: "🥳" },
  { name: "star_struck", emoji: "🤩" },
  { name: "smirk", emoji: "😏" },
  { name: "unamused", emoji: "😒" },
  { name: "disappointed", emoji: "😞" },
  { name: "pensive", emoji: "😔" },
  { name: "worried", emoji: "😟" },
  { name: "confused", emoji: "😕" },
  { name: "cry", emoji: "😢" },
  { name: "sob", emoji: "😭" },
  { name: "pleading", emoji: "🥺" },
  { name: "angry", emoji: "😠" },
  { name: "rage", emoji: "😡" },
  { name: "exploding_head", emoji: "🤯" },
  { name: "flushed", emoji: "😳" },
  { name: "hot", emoji: "🥵" },
  { name: "cold", emoji: "🥶" },
  { name: "scream", emoji: "😱" },
  { name: "fearful", emoji: "😨" },
  { name: "hug", emoji: "🤗" },
  { name: "thinking", emoji: "🤔" },
  { name: "shush", emoji: "🤫" },
  { name: "neutral", emoji: "😐" },
  { name: "eyeroll", emoji: "🙄" },
  { name: "yawn", emoji: "🥱" },
  { name: "sleeping", emoji: "😴" },
  { name: "drool", emoji: "🤤" },
  { name: "woozy", emoji: "🥴" },
  { name: "nauseated", emoji: "🤢" },
  { name: "vomit", emoji: "🤮" },
  { name: "sneeze", emoji: "🤧" },
  { name: "mask", emoji: "😷" },
  { name: "devil", emoji: "😈" },
  { name: "ghost", emoji: "👻" },
  { name: "skull", emoji: "💀" },
  { name: "alien", emoji: "👽" },
  { name: "robot", emoji: "🤖" },
  { name: "poop", emoji: "💩" },
  { name: "clown", emoji: "🤡" },
  { name: "thumbsup", emoji: "👍" },
  { name: "thumbsdown", emoji: "👎" },
  { name: "ok_hand", emoji: "👌" },
  { name: "v", emoji: "✌️" },
  { name: "crossed_fingers", emoji: "🤞" },
  { name: "metal", emoji: "🤘" },
  { name: "call_me", emoji: "🤙" },
  { name: "point_up", emoji: "☝️" },
  { name: "wave", emoji: "👋" },
  { name: "handshake", emoji: "🤝" },
  { name: "pray", emoji: "🙏" },
  { name: "muscle", emoji: "💪" },
  { name: "clap", emoji: "👏" },
  { name: "raised_hands", emoji: "🙌" },
  { name: "shrug", emoji: "🤷" },
  { name: "facepalm", emoji: "🤦" },
  { name: "eyes", emoji: "👀" },
  { name: "brain", emoji: "🧠" },
  { name: "heart", emoji: "❤️" },
  { name: "broken_heart", emoji: "💔" },
  { name: "orange_heart", emoji: "🧡" },
  { name: "yellow_heart", emoji: "💛" },
  { name: "green_heart", emoji: "💚" },
  { name: "blue_heart", emoji: "💙" },
  { name: "purple_heart", emoji: "💜" },
  { name: "black_heart", emoji: "🖤" },
  { name: "white_heart", emoji: "🤍" },
  { name: "sparkling_heart", emoji: "💖" },
  { name: "fire", emoji: "🔥" },
  { name: "sparkles", emoji: "✨" },
  { name: "star", emoji: "⭐" },
  { name: "zap", emoji: "⚡" },
  { name: "boom", emoji: "💥" },
  { name: "100", emoji: "💯" },
  { name: "tada", emoji: "🎉" },
  { name: "confetti", emoji: "🎊" },
  { name: "gift", emoji: "🎁" },
  { name: "trophy", emoji: "🏆" },
  { name: "crown", emoji: "👑" },
  { name: "gem", emoji: "💎" },
  { name: "money", emoji: "💰" },
  { name: "moneybag", emoji: "💰" },
  { name: "money_mouth", emoji: "🤑" },
  { name: "dollar", emoji: "💵" },
  { name: "credit_card", emoji: "💳" },
  { name: "chart", emoji: "📈" },
  { name: "rocket", emoji: "🚀" },
  { name: "check", emoji: "✅" },
  { name: "x", emoji: "❌" },
  { name: "warning", emoji: "⚠️" },
  { name: "question", emoji: "❓" },
  { name: "exclamation", emoji: "❗" },
  { name: "bell", emoji: "🔔" },
  { name: "lock", emoji: "🔒" },
  { name: "key", emoji: "🔑" },
  { name: "bulb", emoji: "💡" },
  { name: "package", emoji: "📦" },
  { name: "shopping_cart", emoji: "🛒" },
  { name: "shopping_bags", emoji: "🛍️" },
  { name: "phone", emoji: "📱" },
  { name: "computer", emoji: "💻" },
  { name: "email", emoji: "📧" },
  { name: "calendar", emoji: "📅" },
  { name: "pin", emoji: "📌" },
  { name: "clock", emoji: "⏰" },
  { name: "hourglass", emoji: "⏳" },
  { name: "eyes_left_right", emoji: "👀" },
  { name: "dog", emoji: "🐶" },
  { name: "cat", emoji: "🐱" },
  { name: "pizza", emoji: "🍕" },
  { name: "burger", emoji: "🍔" },
  { name: "coffee", emoji: "☕" },
  { name: "beer", emoji: "🍺" },
  { name: "sun", emoji: "☀️" },
  { name: "moon", emoji: "🌙" },
  { name: "rainbow", emoji: "🌈" },
  { name: "rain", emoji: "🌧️" },
  { name: "snow", emoji: "❄️" },
];
